import React, { useState } from "react";
import "./FeedbackDialog.css";
import { Dialog, DialogTitle, DialogContent } from "@mui/material";
import { IoMdClose } from "react-icons/io";
import api from "../services/baseUrl";
import Cookies from "js-cookie";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const FeedbackDialog = ({ openDialog, setOpenDialog, showEmail }) => {
  const cookie =
    //Cookies.get("user") ||
    sessionStorage.getItem("user") ||
    Cookies.get("wartaUser") ||
    sessionStorage.getItem("wartaUser");
  const user = JSON.parse(cookie);
  const [errorMessage, setErrorMessage] = useState("");
  const [formData, setFormData] = useState({
    email: "",
    title: "",
    category: "general",
    content: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  
  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(user);
    let formErrors = {};
    setErrorMessage("");

    if(showEmail) {
      if (!formData.email) formErrors.email = "Email is required";
      if (!isValidEmail(formData.email))
        formErrors.email = "Please enter a valid email address";
    }
    if(Object.keys(formErrors).length === 0) {
      console.log("Before sending the enquiries to the backend..");
      try {
        toast.success("Sending your enquiries");
        const response = await api.post("/user/need-help", {
          ...formData,
          email: showEmail ? formData.email : user?.email,
          username: showEmail ? "General Public" : user?.userName || user?.username,
        });
        
      console.log("After sending the enquiries to the backend..");
      console.log(response.status);
        if (response.status === 200) {
          toast.success("Your enquiries has been sent successfully.");
          setFormData({
            title: "",
            category: "general",
            content: "",
          });
          console.log("Before closing the dialog");
              setOpenDialog(false);
          console.log("After closing the dialog");

        }
      } catch (error) {
        console.error("Failed to send message:", error);
      }
    } else {
      console.log(formErrors.email);
      setErrorMessage(formErrors.email)
    }

  };

  return (
    <>
      {" "}
      <Dialog
        open={openDialog}
        PaperProps={{
          style: {
            width: "500px",
            height: "520px",
            borderRadius: "8px",
          },
        }}
      >
        <DialogTitle
          style={{ fontSize: 28, fontWeight: 600, color: "#000000" }}
        >
          Need help?
        </DialogTitle>
        <IoMdClose
          size={30}
          className="dialog-icon"
          onClick={() => setOpenDialog(false)}
        />
        <DialogTitle style={{ marginTop: -30, fontSize: 16, color: "#000000" }}>
          Send us a message and we will get back to you.
        </DialogTitle>
        <DialogContent>
          <form className="dialog-form" onSubmit={handleSubmit}>
            {showEmail && (
              <div className="dialog-input-field">
                <label htmlFor="title">Email</label>
                <input
                  type="text"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
            )}
            {showEmail && errorMessage && (
              <p className="dialog-error-message">{errorMessage}</p>
            )}
            <div className="dialog-input-field">
              <label htmlFor="title">Title</label>
              <input
                type="text"
                name="title"
                value={formData.title}
                onChange={handleChange}
                required
              />
            </div>
            <div className="dialog-input-field">
              <label htmlFor="category">Category</label>
              <select
                name="category"
                value={formData.category}
                onChange={handleChange}
              >
                <option value="General">General</option>
                <option value="Feedback">Feedback</option>
                <option value="Issue">Issue</option>
              </select>
            </div>
            <div className="dialog-input-field">
              <label htmlFor="content">Content</label>
              <textarea
                name="content"
                rows={5}
                value={formData.content}
                onChange={handleChange}
                required
              />
            </div>
            <button className="dialog-button" type="submit">
              Submit
            </button>
          </form>
        </DialogContent>
      </Dialog>{" "}
      <ToastContainer />
    </>
  );
};

export default FeedbackDialog;
